<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-c2">
    <p>
      <strong>{{ 'password.recovery.method.sms.title' | translate }}</strong>
    </p>
    <p class="rs-padding-bottom1">
      {{ 'password.recovery.method.sms.pending.description' | translate }}
    </p>
    <div class="rs-flex-row rs-flex-collapse rs-flex-middle" *ngIf="!showChangeNumber">
      <div class="rs-flex-columns small-9">
        <p>
          <strong class="rs-word-break-all">{{ mobileNumber }}</strong>
        </p>
      </div>
      <div class="rs-flex-columns small-3">
        <p class="text-right">
          <button
            (click)="showChangeNumber = !showChangeNumber"
            class="rs-link-action rs-link-action-edit"
          >
            <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">{{
              'password.recovery.method.sms.pending.edit' | translate
            }}</span
            ><span class="rs-action-link-icon" title="Edit"></span>
          </button>
        </p>
      </div>
    </div>

    <span *ngIf="showChangeNumber">
      <mprd-mobile-number-submit
        (mobileNumberSubmitFormStatusAndValue)="onMobileNumberSubmitFormStatusAndValue($event)"
        (mobileNumberSubmitCancel)="onMobileNumberSubmitCancel()"
      >
      </mprd-mobile-number-submit>
    </span>

    <span *ngIf="!showChangeNumber">
      <p class="text-center medium-text-left">
        <button class="rs-link-action rs-link-action-mail" (click)="setSmsRecovery()">
          <span class="rs-link-action-label" aria-hidden="true">{{
            'password.recovery.method.sms.pending.resend.button' | translate
          }}</span
          ><span class="rs-action-link-icon"></span>
        </button>
      </p>

      <hr />

      <form [formGroup]="activatePendingSmsRecoveryMethodForm">
        <div class="row">
          <div class="small-12 columns">
            <label for="token">
              <span class="rs-label">{{
                'password.recovery.method.sms.pending.token.title' | translate
              }}</span>
              <div class="rs-form-item">
                <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
                  <div class="rs-flex-column">
                    <input
                      formControlName="token"
                      id="token"
                      type="text"
                      autocomplete="off"
                      [ngClass]="{ 'rs-filled': !isTokenEmpty() }"
                    /><label for="token" class="rs-form-label">{{
                      'password.recovery.method.sms.pending.token.insert.code' | translate
                    }}</label>
                  </div>
                </div>
                <div id="ac-helper-alias4" class="rs-form-helper"></div>
              </div>
            </label>
          </div>
        </div>

        <p class="right rs-margin-right2">
          <span *ngIf="showLoadingSpinner">
            <px-loading-spinner></px-loading-spinner>
          </span>
        </p>
        <button
          type="submit"
          class="rs-btn"
          [disabled]="!activatePendingSmsRecoveryMethodForm.valid || showLoadingSpinner"
          [pxAnalyticsElementClicked]="{
            event_detail: 'Confirm recovery phone nbr',
            event_location: 'myWebMail',
            event_action: 'click'
          }"
          (click)="activateSmsRecoveryMethod()"
        >
          {{ 'password.recovery.method.sms.pending.token.button' | translate }}
        </button>
      </form>
    </span>
  </div>
</div>
